export default __webpack_public_path__ + "media/images/jqueryui/ui-anim_basic_16x16-fc0cc44763ad1715f690ccda2b907b9b.gif";